import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, InputNumber } from "antd";
import InputForm from "./InputForm";
import "./Form.css";

const { Item: ItemForm } = Form;
const FormItem = Form.Item;

export default class CondPagtoForm extends Component {
  state = {
    registro: {
      cp_codigo: '',
      cp_descricao: '',
      cp_parcelas: '',
      cp_qtde_parc: 1,
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.data,
        visualizar: this.props.registroSelecionado.visualizar,
      }, () => {
        this.refs.cp_codigo.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onInputChangeQtde = event => {
    const { registro } = this.state;
    registro.cp_qtde_parc = event;
    this.setState({
      registro
    });
  }

  onOK = () => {
    if ((!this.state.registro.cp_descricao) || (this.state.registro.cp_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    if ((!this.state.registro.cp_qtde_parc) || (this.state.registro.cp_qtde_parc === '0')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Qtde de Parcelas' });
      return;
    }

    this.props.onSalvarClick(this.state.registro);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { cp_idf, cp_codigo, cp_descricao, cp_qtde_parc, cp_parc_avista } = this.state.registro;

    return (
      <Modal
        title={cp_idf ? "Edição de Cond. Pagto" : "Cadastro de Cond. Pagto"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={4} className="camposEspacoDireita">
              <span>Código</span>
              <InputForm
                id="cp_codigo"
                ref="cp_codigo"
                onChange={this.onChange}
                value={cp_codigo}
                validator={value => Boolean(value)}
                disabled={true}
              />
            </Col>

            <Col xs={24} sm={20}>
              <span>Descrição *</span>
              <InputForm
                id="cp_descricao"
                ref="cp_descricao"
                maxLength={60}
                onChange={this.onChange}
                value={cp_descricao}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, height: 30 }}>
              <span>Qtde de Parcelas *</span>
              <FormItem>
                <InputNumber
                  ref="Input"
                  id={cp_qtde_parc}
                  value={cp_qtde_parc}
                  onChange={this.onInputChangeQtde}
                  min={1}
                  max={999}
                  maxLength={3}
                  style={{ width:"100%" }}
                />
              </FormItem>
            </Col>

            <Col xs={24} sm={12} className="campoCheckBox" style={{ marginLeft: 15, marginTop: -20 }}>
              <InputForm
                type="checkbox"
                id="cp_parc_avista"
                ref="cp_parc_avista"
                onChange={this.onChange}
                value={cp_parc_avista}
              >
                Contém Parcela À Vista
              </InputForm>
            </Col>

          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CondPagtoForm.js